export default __webpack_public_path__ + "static/media/fenugreek.ad44c945.png";